/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsLocaleCultureString
 */
export interface ControlcenterMelcoModelsLocaleCultureString {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsLocaleCultureString
     */
    culture_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsLocaleCultureString
     */
    culture_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsLocaleCultureString
     */
    text?: string | null;
}

export function ControlcenterMelcoModelsLocaleCultureStringFromJSON(json: any): ControlcenterMelcoModelsLocaleCultureString {
    return ControlcenterMelcoModelsLocaleCultureStringFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsLocaleCultureStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsLocaleCultureString {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'culture_id': !exists(json, 'culture_id') ? undefined : json['culture_id'],
        'culture_code': !exists(json, 'culture_code') ? undefined : json['culture_code'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function ControlcenterMelcoModelsLocaleCultureStringToJSON(value?: ControlcenterMelcoModelsLocaleCultureString | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'culture_id': value.culture_id,
        'culture_code': value.culture_code,
        'text': value.text,
    };
}


